import React from 'react';
import { getResourceTo } from 'react/utils/utils';
import PropTypes from 'prop-types';

const RouteDivisionGridFooter = ({
  splitingRoutes,
  splitRouteAction,
  splitRouteSuccessAction,
  closeModalAction,
  openFormAction,
  backToFormAction
}) => {
  const handleOrderTransfer = async () => {
    try {
      const routeDivisionOrders = new Greenmile.RouteDivisionOrders.Grid();

      splitRouteAction();
      await routeDivisionOrders.transferDataToNewRoute();
      splitRouteSuccessAction();
    } catch (e) {
      console.log(e.message);
    }
  };

  const closeModal = () => {
    closeModalAction();
    openFormAction();
  };

  const backToForm = () => {
    backToFormAction();
  }

  return (
    <div className="formButtons">
      <input
        data-testid="cancel-button"
        type="button"
        value={getResourceTo('default.button.cancel')}
        className={splitingRoutes ? 'submitting' : 'btn-secondary'}
        disabled={splitingRoutes}
        onClick={closeModal}
      />
      <input
        data-testid="close-button"
        type="button"
        value={getResourceTo('default.button.close')}
        className={splitingRoutes ? 'submitting' : 'btn-secondary'}
        disabled={splitingRoutes}
        onClick={closeModal}
      />
      <input
        data-testid="back-button"
        type="button"
        value={getResourceTo('default.button.back')}
        className={splitingRoutes ? 'submitting' : 'btn-secondary'}
        disabled={splitingRoutes}
        onClick={backToForm}
      />
      <input
        data-testid="submit-button"
        type="button"
        value={getResourceTo('default.button.save')}
        className={splitingRoutes ? 'submitting' : ''}
        disabled={splitingRoutes}
        onClick={handleOrderTransfer}
      />
    </div>
  );
};

RouteDivisionGridFooter.propTypes = {
  splitingRoutes: PropTypes.bool.isRequired,
  splitRouteAction: PropTypes.func.isRequired,
  splitRouteSuccessAction: PropTypes.func.isRequired,
  closeModalAction: PropTypes.func.isRequired,
  openFormAction: PropTypes.func.isRequired,
  backToFormAction: PropTypes.func.isRequired
};

export default RouteDivisionGridFooter;
